import { AST } from '@handlebars/parser';

export const DEFAULT_LOCATION: AST.SourceLocation = {
  source: '',
  start: { line: 0, column: 0 },
  end: { line: 0, column: 0 },
};
